import React from 'react';
import { PanelHeader } from '@apply/components';

export const PanelHeaderDemo: React.FC<{}> = ({}) => {
    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Panel Header :</h2>
            <PanelHeader>Draws Mobile Header Panel</PanelHeader>
        </div>
    );
};
